import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import Historial from "../historial.vue";
export default {
    data() {
        return {
            dialogHistorial: false,
            dialogLoader: false,
            searchAutogenerado: null,
            salasItems: [
                { label: "Clínicas", value: "0" },
                { label: "S1 CNSR", value: "1" },
                { label: "S2 CNSR", value: "2" },
                { label: "S3 CNSR", value: "3" },
                { label: "S4 CNSR", value: "4" },
                { label: "S5 DP", value: "5" }
            ],
            searchSala: [],
            statusEdit: true,
            hoveredItem: null,
            popupStyles: {
                top: '-8000px',
                left: '0px'
            },
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchSubactividad: null,
            searchDNI: null,
            dialogLoader: false,
            dataPaciente: [],
            search: "",
            headers: [
                { text: "SALA", value: "SALA", align: "center" },
                { text: "AUTOGENERADO", value: "AUTOGENERADO", align: "center" },
                { text: "PACIENTE", value: "PACIENTE", align: "center" },
                { text: "NUM DOC", value: "NUM_DOC", align: "center" },
                /*
                { text: "PAS", value: "PAS", align: "center" },
                { text: "PAD", value: "PAD", align: "center" },
                */
                { text: "IECA", value: "IECA", align: "center" },
                { text: "DOSIS IECA", value: "DOSIS_IECA", align: "center" },
                { text: "ARA 2", value: "ARA_2", align: "center" },
                { text: "DOSIS ARA 2", value: "DOSIS_ARA_2", align: "center" },
                { text: "CALCIO ANTAGON", value: "CALCIO_ANTAGON", align: "center" },
                { text: "DOSIS CALCIO ANTAGON", value: "DOSIS_CALCIO_ANTAGON", align: "center" },
                { text: "ACC SNC", value: "ACC_SNC", align: "center" },
                { text: "DOSIS ACC SNC", value: "DOSIS_ACC_SNC", align: "center" },
                { text: "BETABLOQ", value: "BETABLOQ", align: "center" },
                { text: "DOSIS BETABLOQ", value: "DOSIS_BETABLOQ", align: "center" },
                { text: "OBSERVACIONES", value: "OBSERVACIONES", align: "center" },
                { text: "ACCIONES", value: "actions", align: "center" }
            ],
            dialogEdit: false,
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            selectedColumns: ['PACIENTE',
                'NUM_DOC',
                'PAS',
                'PAD',
                'IECA',
                'DOSIS_IECA',
                'ARA_2',
                'DOSIS_ARA_2',
                'CALCIO_ANTAGON',
                'DOSIS_CALCIO_ANTAGON',
                'ACC_SNC',
                'DOSIS_ACC_SNC',
                'BETABLOQ',
                'DOSIS_BETABLOQ',
                'SALA',
                'AUTOGENERADO', 'OBSERVACIONES', 'actions'],
            itemMes: null,
            itemPeriodo: null,
            dataArray: []
        };
    },
    methods: {
        openHistorial(event, item) {
            this.hoveredItem = item;
            this.dialogHistorial = true;
        },
        closeHistorial() {
            this.dialogHistorial = false;
        },
        save() {
            for (let i = 0; i < this.dataArray.length; i++) {
                const element = this.dataArray[i];
                this.isLoading = true;
                this.dialogLoader = true;
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/generar_actualizar_protocolo_hta/", { "ID": element.ID, "PAS": element.PAS, "PAD": element.PAD, "IECA": element.IECA, "DOSIS_IECA": element.DOSIS_IECA, "ARA_2": element.ARA_2, "DOSIS_ARA_2": element.DOSIS_ARA_2, "CALCIO_ANTAGON": element.CALCIO_ANTAGON, "DOSIS_CALCIO_ANTAGON": element.DOSIS_CALCIO_ANTAGON, "ACC_SNC": element.ACC_SNC, "DOSIS_ACC_SNC": element.DOSIS_ACC_SNC, "BETABLOQ": element.BETABLOQ, "DOSIS_BETABLOQ": element.DOSIS_BETABLOQ, "OBSERVACIONES": element.OBSERVACIONES }, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {
                                if (this.dataArray.length == i + 1) {
                                    this.isLoading = false;
                                    this.dataInit();
                                    this.dialogLoader = false;
                                    this.dataArray = [];
                                    this.statusEdit = true;
                                    Swal.fire({
                                        title: "¡Listo!",
                                        text: "Se guardaron los cambios.",
                                        icon: "success",
                                        confirmButtonText: "Aceptar"
                                    });
                                    return;
                                }
                            })
                            .catch((res) => {
                                this.dialogLoader = false;
                                Swal.fire({
                                    title: "¡Error!",
                                    text: error.response.data.error || "No se guardaron los cambios.",
                                    icon: "error",
                                    confirmButtonText: "Aceptar"
                                });
                                return;
                            });
                    })
                    .catch((response) => {
                        this.dialogLoader = false;

                        response === 404
                            ? console.warn("lo sientimos no tenemos servicios")
                            : console.warn("Error:", response);
                    });
            };
            this.statusEdit = true;
        },
        onInputChange(valor) {
            // Verifica si el array ya existe en `this.dataArray`
            const existe = this.dataArray.some(
                (arr) => JSON.stringify(arr.NUM_DOC) === JSON.stringify(valor.NUM_DOC)
            );
            if (!existe) {
                this.dataArray.push(valor);
            }

        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.dataInit();
        },
        exportExcel() {
            // Importar xlsx-js-style
            const XLSXStyle = require("xlsx-js-style");

            // Definir cabecera
            const headers = this.selectedColumns.map(column => {
                const header = this.headers.find(h => h.value === column);
                return header ? header.text : column;
            });

            // Convertir datos a formato adecuado para la hoja de cálculo
            const datos = this.filteredData;

            // Inicializar rows con los encabezados
            const rows = [headers];

            // Añadir datos a las filas
            datos.forEach(item => {
                const row = this.selectedColumns.map(column => item[column]);
                rows.push(row);
            });

            // Crear una hoja de cálculo
            const worksheetData = rows;
            const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
            // Define el rango para el filtro, por ejemplo, desde A1 hasta la última columna de la fila de encabezados

            const rangoFiltro = `A1:${XLSXStyle.utils.encode_col(headers.length - 1)}1`;

            // Agregar el filtro al rango definido
            worksheet['!autofilter'] = { ref: rangoFiltro };
            // Aplicar estilo a las celdas
            // Estilo para el borde de todas las celdas
            const cellStyle = {
                alignment: { horizontal: 'center', vertical: 'center' },  // Centrar texto
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };

            // Estilo específico para la cabecera (relleno plomo, texto blanco)
            const headerStyle = {
                fill: { fgColor: { rgb: "7A7A7A" } },
                font: { color: { rgb: "FFFFFF" }, bold: true },
                alignment: { horizontal: 'center', vertical: 'center', wrapText: true },  // Centrar texto
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };


            // Aplicar estilo a todas las celdas (bordes negros)
            rows.forEach((row, rowIndex) => {
                row.forEach((_, colIndex) => {
                    const cellRef = XLSXStyle.utils.encode_cell({ c: colIndex, r: rowIndex });
                    if (!worksheet[cellRef]) worksheet[cellRef] = {}; // Si la celda no existe, la crea
                    worksheet[cellRef].s = cellStyle; // Aplicar estilo
                });
            });
            //Aplicar filtro a todas las cabeceras
            headers.forEach((header, index) => {
                const cellRef = XLSXStyle.utils.encode_cell({ c: index, r: 0 });
                worksheet[cellRef].s = headerStyle;
            });
            // Crear el libro de trabajo y añadir la hoja
            const workbook = XLSXStyle.utils.book_new();
            XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Protocolo tha');

            // Exportar a archivo Excel
            XLSXStyle.writeFile(workbook, 'Protocolo_tha.xlsx');
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_protocolo_hta/", { "fecha": this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        filteredData() {
            if (!this.searchSubactividad && !this.searchDNI && !this.searchAutogenerado && this.searchSala.length == 0) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchSubactividad) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.PACIENTE;
                    return nombreCompleto.toLowerCase().includes(this.searchSubactividad.toLowerCase());
                });
            }
            if (this.searchDNI) {
                filtered = filtered.filter((item) =>
                    item.NUM_DOC
                        .toLowerCase()
                        .includes(this.searchDNI.toLowerCase())
                );
            }
            if (this.searchAutogenerado) {
                filtered = filtered.filter((item) =>
                    item.AUTOGENERADO
                        .toLowerCase()
                        .includes(this.searchAutogenerado.toLowerCase())
                );
            }
            if (this.searchSala.length !== 0) {
                filtered = filtered.filter((item) =>
                    this.searchSala.some((SALA) =>
                        item.SALA.toLowerCase().includes(SALA.toLowerCase())
                    )
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadPeriodo();
    },
    components: {
        Historial
    },
};